module.exports = __webpack_public_path__ + "static/img/growth.6ff8a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/growth.jpg
// module id = k9NU
// module chunks = 1